// extracted by mini-css-extract-plugin
export default {"about-image":"About_about-image__2jND+","about-paragraph":"About_about-paragraph__Hjkjl"};